import React, { Fragment } from 'react'

import { PurchaseTypes, type PurchaseType } from '@/constants/programs'
import type { Delivery, DeliveryZone } from '@/models/delivery-zone'
import dayjs from '@/utilities/dayjs-config'
import { formatDeliveryWindow } from '@/utilities/sakara'

type Props = {
  template: string
  deliveryZone: DeliveryZone
  deliveries: Delivery[]
  purchaseType: PurchaseType
}

export const DeliveryMessage: React.FC<Props> = ({
  template,
  deliveryZone,
  deliveries,
  purchaseType,
}) => {
  const deliveryCount = deliveries.length == 1 ? '' : deliveries.length
  const deliveryWeekdays = deliveries.map((delivery) => delivery.day).join('+')
  const deliveryWindows =
    deliveryZone && formatDeliveryWindow(deliveryZone.defaultDeliveryWindow)
  const subscriptionSuffix =
    purchaseType === PurchaseTypes.SUBSCRIPTION ? ' per week' : ''
  const deliveryWindowStart = dayjs(
    deliveryZone?.defaultDeliveryWindow[0],
    'HH:mm',
  ).format('hA')
  const deliveryWindowEnd = dayjs(
    deliveryZone?.defaultDeliveryWindow[1],
    'HH:mm',
  ).format('hA')

  const renderTemplateString = (template: string, deliveryDay?: string) => {
    let result = template
      .replaceAll('#DELIVERY_COUNT', deliveryCount.toString())
      .replaceAll('#DELIVERY_WEEKDAYS', deliveryWeekdays)
      .replaceAll('#DELIVERY_WINDOWS', deliveryWindows!)
      .replaceAll('#SUBSCRIPTION_SUFFIX', subscriptionSuffix)

    if (deliveryDay) {
      result = result
        .replaceAll('#DELIVERY_DAY', deliveryDay)
        .replaceAll('#DELIVERY_WINDOW_START', deliveryWindowStart)
        .replaceAll('#DELIVERY_WINDOW_END', deliveryWindowEnd)
    }

    return result
      .split('\n')
      .filter(Boolean)
      .map((line, index) => (
        <Fragment key={index}>
          <span key={index}>{line}</span>
          <br />
        </Fragment>
      ))
  }

  const splitted = template.split(/(#DELIVERY_ITEMS\[.+?\])/)

  return (
    <div className="delivery-message">
      {splitted.map((part, index) => {
        if (part.startsWith('#DELIVERY_ITEMS')) {
          const match = part.match(/#DELIVERY_ITEMS\[(.+?)\]/)
          if (!match) return null

          return (
            <ul key={index}>
              {deliveries.map((delivery) => (
                <li key={delivery.day}>
                  {renderTemplateString(match[1], delivery.day)}
                </li>
              ))}
            </ul>
          )
        }
        return <div key={index}>{renderTemplateString(part)}</div>
      })}
    </div>
  )
}
